/**
 * Rules for sending signed-out visitors to sign up.
 *
 * Challenge and lesson pages stay public (search engines and shared links still work).
 * Only *clicks* on their CTAs from inside the site are redirected, see
 * components/auth/guest-cta-gate.tsx. Any other link can opt in with `data-requires-auth`.
 */

/** Opt-in attribute for CTAs whose target route is not gated by path. */
export const REQUIRES_AUTH_ATTR = "data-requires-auth";

/** /challenges/<slug> (not the library itself) and /courses/<course>/<lesson>. */
const GATED_PATHS: readonly RegExp[] = [/^\/challenges\/[^/]+\/?$/, /^\/courses\/[^/]+\/[^/]+\/?$/];

export function isGatedPath(pathname: string): boolean {
  return GATED_PATHS.some((pattern) => pattern.test(pathname));
}

/** Sign-up URL that returns the user to `next` afterwards (auth-form honours `?next=`). */
export function signupHref(next: string): string {
  return `/signup?next=${encodeURIComponent(next)}`;
}

export function currentPath(): string {
  return `${window.location.pathname}${window.location.search}`;
}

/**
 * True when the page is driven by a test runner or embedded by the app
 * (cloud Playwright/Selenium runners set navigator.webdriver; the workspace and
 * in-browser runner load labs in iframes). These must never be redirected.
 */
export function isAutomatedOrEmbedded(): boolean {
  if (navigator.webdriver) return true;
  try {
    return window.self !== window.top;
  } catch {
    return true; // cross-origin parent: embedded
  }
}
